import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Tone } from 'src/app/domain/status'

export interface FilterChip { readonly key: string; readonly label: string; readonly count: number; readonly tone: Tone | null }

/** Status filter row (paperwork lists, WOR list, Support). `tone: null` is the steel "All" dot. */
@Component({
  selector: 'rt-filter-chips',
  template: `
    <div class="rt-chips" role="group">
      <button *ngFor="let c of chips; trackBy: byKey" type="button"
              class="rt-chip rt-chip--filter rt-tone-{{ c.tone ?? 'muted' }}" [class.rt-chip--all]="!c.tone"
              [class.is-selected]="c.key === selected" [attr.aria-pressed]="c.key === selected" (click)="pick.emit(c.key)">
        {{ c.label }} <span class="rt-chip__count">{{ c.count }}</span>
      </button>
    </div>`,
})
export class RtFilterChipsComponent {
  @Input() chips: readonly FilterChip[] = []
  @Input() selected = ''
  @Output() readonly pick = new EventEmitter<string>()
  byKey = (_: number, c: FilterChip) => c.key
}
